import * as React from 'react';
import { DocumentHead, LoadingIndicator, PageTemplate } from 'lib/components';
import { RouteComponentProps } from 'react-router';
import { withRouter } from 'react-router-dom';
import { text } from 'lib/utils';
import { VideoData } from 'lib/hooks';
import { usePlayerDesignQuery } from 'lib/api/playerDesign/usePlayerDesignQuery';
import { PreLoader } from '.';
import { NotFound } from 'app/pages/notFound/NotFound';
import { DeleteVideoModal } from 'lib/components/modal/DeleteVideoModal';
import { getVideo } from 'lib/api/videos/useSingleVideoQuery';
import { useTranslation } from 'react-i18next';

interface MatchParams {
  videoId: string;
  view: string;
}

export const VideoDetails = withRouter(
  (props: RouteComponentProps<MatchParams>) => {
    const { t } = useTranslation();
    const { videoId, view } = props.match.params;
    const { history } = props;
    const [_, setVideoIdState] = React.useState(videoId);
    const [showVideoDeleteModal, setShowVideoDeleteModal] =
      React.useState(false);
    const [loading, setLoading] = React.useState(true);
    const [reloadVideoDetails, setReloadVideoDetails] = React.useState(false);
    const [videoDetails, setVideoDetails] = React.useState({} as VideoData);

    const { data: videoAppearanceData, isLoading: videoAppearanceLoading } =
      usePlayerDesignQuery({ options: {} });

    const openVideoDeleteModal = () => {
      setShowVideoDeleteModal(true);
    };

    const closeVideoDeleteModal = () => {
      setShowVideoDeleteModal(false);
      history.push('/');
    };

    const renderDeleteVideoModal = () => {
      return (
        <DeleteVideoModal
          content={text.deleteModal.deleteModalBody}
          handleModalClose={closeVideoDeleteModal}
          video={[videoDetails]}
          isCompanyVideo={false}
        />
      );
    };

    React.useEffect(() => {
      const getVideoDetails = async () => {
        const video = await getVideo(videoId).catch(() => null);
        setVideoDetails(video);
        setLoading(false);
      };
      getVideoDetails();
    }, [reloadVideoDetails]);

    if (loading || videoAppearanceLoading || !videoAppearanceData) {
      return <LoadingIndicator isLoading={true} />;
    }

    if (!videoDetails) {
      return <NotFound />;
    }

    return (
      <>
        <DocumentHead title={t('Video Details')} />
        <PageTemplate
          modal={showVideoDeleteModal ? [renderDeleteVideoModal()] : [null]}
          main={
            <PreLoader
              videoDetails={videoDetails}
              setReloadVideoDetails={setReloadVideoDetails}
              videoAppearanceData={videoAppearanceData}
              view={view}
              openVideoDeleteModal={openVideoDeleteModal}
              setVideoIdState={setVideoIdState}
            />
          }
        />
      </>
    );
  }
);
